import HttpClient from '@/common/boot/HttpClient'
import { sanitizarDestinatariosParaPayload } from '../helpers/destinatarios'

const BASE_URL = '/notification-templates'

const montarParams = (state, extra = {}) => {
  const { filtros, paginacao } = state
  const params = {
    page: paginacao.current_page || 1,
    per_page: paginacao.per_page || 15,
    sort: filtros.sort,
    direction: filtros.direction,
    ...extra
  }
  if (filtros.is_active !== null && filtros.is_active !== '') {
    params.is_active = filtros.is_active
  }
  if (filtros.event_key) {
    params.event_key = filtros.event_key
  }
  return params
}

const listarTemplates = async ({ commit, state }, extra = {}) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.get(BASE_URL, { params: montarParams(state, extra) })
    commit('LISTAR_DADOS', response.data?.data || response.data)
    return response
  } finally {
    commit('CARREGANDO', false)
  }
}

const buscarTemplate = async ({ commit }, id) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.get(`${BASE_URL}/${id}`)
    const data = response.data?.data || response.data
    commit('SELECIONAR', data)
    return data
  } finally {
    commit('CARREGANDO', false)
  }
}

const salvarTemplate = async ({ commit, dispatch }, payload) => {
  commit('SALVANDO', true)
  try {
    const response = await HttpClient.post(BASE_URL, payload)
    const data = response.data?.data || response.data
    if (data) commit('INSERIR_ITEM', data)
    dispatch('listarTemplates')
    return data
  } finally {
    commit('SALVANDO', false)
  }
}

const sanitizarPayload = (payload) => {
  const { id, name, description, subject, body, is_active, recipients } = payload
  const limpo = { name, description, subject, body, is_active }
  if (id) limpo.id = id
  if (recipients !== undefined) limpo.recipients = recipients
  return limpo
}

const atualizarTemplate = async ({ commit, dispatch }, payload) => {
  commit('SALVANDO', true)
  try {
    const limpo = sanitizarPayload(payload)
    const response = await HttpClient.put(`${BASE_URL}/${limpo.id}`, limpo)
    const data = response.data?.data || response.data
    if (data) commit('ATUALIZAR_ITEM', data)
    dispatch('listarTemplates')
    return data
  } finally {
    commit('SALVANDO', false)
  }
}

const alternarStatusTemplate = async ({ dispatch }, template) => {
  return dispatch('atualizarTemplate', {
    id: template.id,
    name: template.name,
    description: template.description,
    subject: template.subject,
    body: template.body,
    is_active: !template.is_active,
    recipients: sanitizarDestinatariosParaPayload(template.recipients)
  })
}

const atualizarFiltros = ({ commit }, payload) => {
  commit('ATUALIZAR_FILTROS', payload)
}

const limparSelecionado = ({ commit }) => {
  commit('SELECIONAR', null)
}

export {
  listarTemplates,
  buscarTemplate,
  salvarTemplate,
  atualizarTemplate,
  alternarStatusTemplate,
  atualizarFiltros,
  limparSelecionado
}
